export const NOTIFICATION_SHOW = "NOTIFICATION_SHOW";
export const NOTIFICATION_DISMISS = "NOTIFICATION_DISMISS";
export const NOTIFICATION_CLEAR = "NOTIFICATION_CLEAR";
